var map = {
	"./assets/arnolfini-portrait/artist.jpg": 6000,
	"./assets/arnolfini-portrait/gallery.jpg": 7389,
	"./assets/arnolfini-portrait/hero-large.jpg": 8818,
	"./assets/arnolfini-portrait/hero-small.jpg": 9649,
	"./assets/arnolfini-portrait/thumbnail.jpg": 9944,
	"./assets/girl-with-a-pearl-earring/artist.jpg": 9181,
	"./assets/girl-with-a-pearl-earring/gallery.jpg": 5465,
	"./assets/girl-with-a-pearl-earring/hero-large.jpg": 6196,
	"./assets/girl-with-a-pearl-earring/hero-small.jpg": 6981,
	"./assets/girl-with-a-pearl-earring/thumbnail.jpg": 1722,
	"./assets/guernica/artist.jpg": 7704,
	"./assets/guernica/gallery.jpg": 1854,
	"./assets/guernica/hero-large.jpg": 8299,
	"./assets/guernica/hero-small.jpg": 6395,
	"./assets/guernica/thumbnail.jpg": 895,
	"./assets/lady-with-an-ermine/artist.jpg": 7611,
	"./assets/lady-with-an-ermine/gallery.jpg": 8286,
	"./assets/lady-with-an-ermine/hero-large.jpg": 9801,
	"./assets/lady-with-an-ermine/hero-small.jpg": 5747,
	"./assets/lady-with-an-ermine/thumbnail.jpg": 7031,
	"./assets/mona-lisa/artist.jpg": 4546,
	"./assets/mona-lisa/gallery.jpg": 1818,
	"./assets/mona-lisa/hero-large.jpg": 3233,
	"./assets/mona-lisa/hero-small.jpg": 263,
	"./assets/mona-lisa/thumbnail.jpg": 7979,
	"./assets/penitent-magdalene/artist.jpg": 75,
	"./assets/penitent-magdalene/gallery.jpg": 2137,
	"./assets/penitent-magdalene/hero-large.jpg": 4181,
	"./assets/penitent-magdalene/hero-small.jpg": 5809,
	"./assets/penitent-magdalene/thumbnail.jpg": 4285,
	"./assets/starry-night/artist.jpg": 3207,
	"./assets/starry-night/gallery.jpg": 255,
	"./assets/starry-night/hero-large.jpg": 6430,
	"./assets/starry-night/hero-small.jpg": 3619,
	"./assets/starry-night/thumbnail.jpg": 1794,
	"./assets/the-basket-of-apples/artist.jpg": 9170,
	"./assets/the-basket-of-apples/gallery.jpg": 5025,
	"./assets/the-basket-of-apples/hero-large.jpg": 7257,
	"./assets/the-basket-of-apples/hero-small.jpg": 2905,
	"./assets/the-basket-of-apples/thumbnail.jpg": 3719,
	"./assets/the-boy-in-the-red-vest/artist.jpg": 7186,
	"./assets/the-boy-in-the-red-vest/gallery.jpg": 3287,
	"./assets/the-boy-in-the-red-vest/hero-large.jpg": 9866,
	"./assets/the-boy-in-the-red-vest/hero-small.jpg": 7422,
	"./assets/the-boy-in-the-red-vest/thumbnail.jpg": 877,
	"./assets/the-great-wave-off-kanagawa/artist.jpg": 7787,
	"./assets/the-great-wave-off-kanagawa/gallery.jpg": 4710,
	"./assets/the-great-wave-off-kanagawa/hero-large.jpg": 6070,
	"./assets/the-great-wave-off-kanagawa/hero-small.jpg": 528,
	"./assets/the-great-wave-off-kanagawa/thumbnail.jpg": 8018,
	"./assets/the-night-cafe/artist.jpg": 5484,
	"./assets/the-night-cafe/gallery.jpg": 8907,
	"./assets/the-night-cafe/hero-large.jpg": 3434,
	"./assets/the-night-cafe/hero-small.jpg": 505,
	"./assets/the-night-cafe/thumbnail.jpg": 6798,
	"./assets/the-sleeping-gypsy/artist.jpg": 9657,
	"./assets/the-sleeping-gypsy/gallery.jpg": 7629,
	"./assets/the-sleeping-gypsy/hero-large.jpg": 5094,
	"./assets/the-sleeping-gypsy/hero-small.jpg": 8630,
	"./assets/the-sleeping-gypsy/thumbnail.jpg": 3535,
	"./assets/the-storm-on-the-sea-of-galilee/artist.jpg": 5580,
	"./assets/the-storm-on-the-sea-of-galilee/gallery.jpg": 5338,
	"./assets/the-storm-on-the-sea-of-galilee/hero-large.jpg": 2610,
	"./assets/the-storm-on-the-sea-of-galilee/hero-small.jpg": 3621,
	"./assets/the-storm-on-the-sea-of-galilee/thumbnail.jpg": 357,
	"./assets/the-swing/artist.jpg": 7930,
	"./assets/the-swing/gallery.jpg": 213,
	"./assets/the-swing/hero-large.jpg": 9800,
	"./assets/the-swing/hero-small.jpg": 682,
	"./assets/the-swing/thumbnail.jpg": 6594,
	"./assets/van-gogh-self-portrait/artist.jpg": 7385,
	"./assets/van-gogh-self-portrait/gallery.jpg": 1765,
	"./assets/van-gogh-self-portrait/hero-large.jpg": 7088,
	"./assets/van-gogh-self-portrait/hero-small.jpg": 2820,
	"./assets/van-gogh-self-portrait/thumbnail.jpg": 5354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2027;